import { useQuery } from '@tanstack/react-query';
import Globals from '../Globals.json';
import api from '../Services/api';

interface Product {
  // defina os campos se quiser tipagem mais precisa
  id: number;
  name: string;
  // ...
}

interface UseProductsCombinedOptions {
  name?: string;
  storeId?: number;
}

export const useProductsCombined = ({
  name,
  storeId,
}: UseProductsCombinedOptions) => {
  return useQuery<any, Error>({
    queryKey: ['products-combined', storeId, name],
    queryFn: async () => {
      if (!storeId) return [];

      const baseParams = `paginate=false&store_id=${storeId}`;
      const nameFilter =
        name && name.length > 2
          ? `&filter[product_name]=${encodeURIComponent(name)}`
          : '';

      const uri1 = `/minified?filter[product_type_id]=3&filter[is_active]=1&${baseParams}${nameFilter}&id_number=39`;
      const uri2 = `/minified?filter[product_type_id]=8&filter[is_active]=1&${baseParams}${nameFilter}&id_number=40`;

      const [res1, res2] = await Promise.all([
        api.get(Globals.api.products + uri1),
        api.get(Globals.api.products + uri2),
      ]);

      const list1 = res1?.data?.data || [];
      const list2 = res2?.data?.data || [];

      return [...list1, ...list2];
    },
    enabled: !!storeId,
    refetchInterval: false, // formulário/dado de referência: sem atualização automática
  });
};
